module.exports = [typeAheadFactory];

function typeAheadFactory() {
    var service = {
        makePropertyTypeaheadFilter: makePropertyTypeaheadFilter
    };
    return service;
}

// Takes care of ordering the results of a typeahead, based on a single property with name propertyName. 
// The property is expected to be a string.
//
// The logic is as follows:
// - First, show the matches at the beginning of the property, ordered by property
// - Next, show the matches which are not at the beginning of the property, ordered by property
// - Finally, show non-matching items, ordered by property
//
// NB: this needs to be used in combination with a regular filter, since it does not take
// care of removing results which don't match the query at all
function makePropertyTypeaheadFilter(propertyName) {
    return (items, query) => {
        if (query === null || query === undefined || query === '') {
            return items;
        }

        // Partition into items with item[propertyName] starting with the query and those that don't
        var startMatchPartition = _.partition(items, function(item) {
            return item[propertyName] && item[propertyName].toLowerCase().indexOf(query.toLowerCase()) === 0;
        });
        
        // Partition into items with item[propertyName] containing the query and those that don't
        var middleMatchPartition = _.partition(startMatchPartition[1], function(item) {
            return item[propertyName] && item[propertyName].toLowerCase().indexOf(query.toLowerCase()) > -1;
        });

        var startMatches = _.sortBy(startMatchPartition[0], propertyName);
        var otherMatches = _.sortBy(middleMatchPartition[0], propertyName);
        var nonMatches = _.sortBy(middleMatchPartition[1], propertyName);

        var result = _.concat(startMatches, otherMatches, nonMatches);
        
        return result;
    }
}